/**
 * Created by Jan Bradac on 9.5.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.FlashMessages;

    (function (FlashMessages, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.FlashMessages, 'KeeperOnScreen')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Allows the flash messages to stay on screen when user rolls down.
         * @memberOf Lfl.FlashMessages
         */
        Lfl.FlashMessages.KeeperOnScreen;

        (function (KeeperOnScreen, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * Engages the functionality for given flash message
             * @memberOf Lfl.FlashMessages.KeeperOnScreen
             */
            KeeperOnScreen.keepOnScreen = function(flashMessageId) {
                FunctionsCaller.register(function($) {
                    var $flashMessage = $('#' + flashMessageId);
                    // check where the element is
                    var offset = $flashMessage.offset();

                    var scrollTop = $(window).scrollTop();

                    // check the visible top of the browser when initializing
                    if (offset.top<scrollTop) {
                        $flashMessage.addClass('lfl-keep-on-screen');
                    }


                    // Detect and adjust on each user scroll
                    $(window).scroll(function () {
                        var scrollTop = $(window).scrollTop();
                        // check the visible top of the browser
                        if (offset.top<scrollTop) {
                            $flashMessage.addClass('lfl-keep-on-screen');
                        } else {
                            $flashMessage.removeClass('lfl-keep-on-screen');
                        }
                    });
                });
            };
            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(FlashMessages.KeeperOnScreen = FlashMessages.KeeperOnScreen || {}, jQuery));
    }(Lfl.FlashMessages = Lfl.FlashMessages || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));